<template>
    <div class="customers-info-section">
        <div class="row">
            <div class="col-md-3 col-sm-12 text-center profile-image-section">
                <div v-if="customerDetails.pictureURL" class="customer-profile">
                    <img v-authenticated-image="customerDetails.pictureURL" />
                </div>

                <base-status
                    v-if="customerDetails.status"
                    :status-type="customerDetails.status"
                ></base-status>
            </div>
            <div class="col-md-9 col-sm-12">
                <ul>
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Customer Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Idenfo ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.idenfoId
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Bank Customer ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.bankCustomerId
                                                    ? customerDetails.bankCustomerId
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                v-if="
                                                    customerDetails.dataSegment &&
                                                    (customerDetails.dataSegment[0].code == 'HBC' || customerDetails.dataSegment[0].code == 'VEN')

                                                "
                                                >Corporate Name</label
                                            >
                                            <label v-else>Full Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.firstName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!--                                <div class="col-md-6">-->
                                <!--                                    <ul class="row">-->
                                <!--                                        <li class="col-md-6">-->
                                <!--                                            <label>Middle Name:</label>-->
                                <!--                                        </li>-->
                                <!--                                        <li class="col-md-6">-->
                                <!--                                            <span class="">{{-->
                                <!--                                                customerDetails.middleName-->
                                <!--                                                    ? customerDetails.middleName-->
                                <!--                                                    : 'N/A'-->
                                <!--                                            }}</span>-->
                                <!--                                        </li>-->
                                <!--                                    </ul>-->
                                <!--                                </div>-->
                                <div
                                    v-if="
                                        customerDetails.identityInfo &&
                                        customerDetails.identityInfo.number
                                    "
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                v-if="
                                                    customerDetails.dataSegment &&
                                                    (customerDetails.dataSegment[0].code == 'HBC' || customerDetails.dataSegment[0].code == 'VEN')

                                                "
                                                >CUIN/DOCUMENT NUMBER</label
                                            >
                                            <label v-else>CNIC</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Gender:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.gender
                                                    ? customerDetails.gender
                                                          .title
                                                    : ''
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Date of Birth:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.dateOfBirth
                                                "
                                                >{{
                                                    customerDetails.dateOfBirth
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                v-if="
                                                    customerDetails.dataSegment &&
                                                    (customerDetails.dataSegment[0].code == 'HBC' || customerDetails.dataSegment[0].code == 'VEN')
                                                "
                                                >Country Of Incorporation</label
                                            >
                                            <label v-else
                                                >Country of Residence:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.countryOfResidenceIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.countryOfResidence
                                                        ? customerDetails
                                                              .countryOfResidence
                                                              .title
                                                        : ''
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Nationality:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.nationalityIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.nationality
                                                        ? customerDetails
                                                              .nationality.title
                                                        : ''
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Record Last Updated:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="customerDetails.updatedAt"
                                                >{{
                                                    customerDetails.updatedAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Father Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span>{{
                                                customerDetails.fatherName ||
                                                customerDetails.fatherOrHusbandName ||
                                                'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul
                    v-if="
                        customerDetails &&
                        customerDetails.dataSegment &&
                        (customerDetails.dataSegment[0].code !== 'HBC' && customerDetails.dataSegment[0].code !== 'VEN')
                        "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Residential Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Nationality:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.nationalityIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.nationality
                                                        ? customerDetails
                                                              .nationality.title
                                                        : ''
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Country of Residence:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.countryOfResidenceIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.countryOfResidence
                                                        ? customerDetails
                                                              .countryOfResidence
                                                              .title
                                                        : ''
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul
                    v-if="
                        customerDetails.identityInfo &&
                        customerDetails.identityInfo.number &&
                        customerDetails.dataSegment &&
                        (customerDetails.dataSegment[0].code !== 'HBC' && customerDetails.dataSegment[0].code !== 'VEN')
                        "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>ID Document</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Document Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .type | identityInfoType
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-if="customerDetails.identityInfo.number"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- Show or Hide Details form Sections-->
                <div>
                    <!-- Attorney Info Begin -->
                    <ul
                        v-if="
                            segmentType == 'Details' &&
                            customerDetails.attorneyInfo &&
                            Object.keys(customerDetails.attorneyInfo).length
                        "
                    >
                        <li>
                            <div class="seprator-section">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h3>Attorney Information</h3>
                                    </div>
                                    <div
                                        v-for="(
                                            value, key
                                        ) in customerDetails.attorneyInfo"
                                        :key="key"
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>{{
                                                    startCase(key)
                                                }}</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span>{{ value }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!-- Attorney Info End -->
                    <!-- Nominee Info Begin -->
                    <ul
                        v-if="
                            segmentType == 'Details' &&
                            customerDetails.nomineeInfo &&
                            Object.keys(customerDetails.nomineeInfo).length
                        "
                    >
                        <li>
                            <div class="seprator-section">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h3>Nominee Information</h3>
                                    </div>
                                    <div
                                        v-for="(
                                            value, key
                                        ) in customerDetails.nomineeInfo"
                                        :key="key"
                                        class="col-md-6"
                                    >
                                        <ul class="row">
                                            <li class="col-md-6">
                                                <label>{{
                                                    startCase(key)
                                                }}</label>
                                            </li>
                                            <li class="col-md-6">
                                                <span>{{ value }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!-- Nominee Info End -->
                </div>
                <!-- END of Show or Hide Details form Sections-->
                <ul
                    v-if="
                        customerDetails.customInfo &&
                        Object.keys(customerDetails.customInfo).length
                    "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Additional Information</h3>
                                </div>
                                <div
                                    v-for="(
                                        info, index
                                    ) in customerDetails.customInfo"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ info.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="info.type == 'text-field'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="info.type == 'text-area'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !!info.value
                                                "
                                                >{{
                                                    info.value
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !info.value
                                                "
                                                >N/A</span
                                            >
                                            <span
                                                v-if="info.type == 'dropdown'"
                                                >{{ info.value }}</span
                                            >
                                            <span v-if="info.type == 'radio'">{{
                                                info.value
                                            }}</span>
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    info.value
                                                "
                                                >{{
                                                    info.value.join(', ')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    !info.value
                                                "
                                            >
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > filters
    |--------------------------------------------------------------------------
    */
    filters: {
        identityInfoType: function (value) {
            switch (value) {
                case 'id':
                    return 'National ID Card'

                case 'licence':
                    return 'Driving Licence'

                case 'passport':
                    return 'Passport'
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        customerDetails: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            declarationByCustomer: [],
            pepDeclaration: [],
            ultimateBenefit: [],
            factaDetails: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.assigningCustomerDataToFields()
        debugger
        // this.customerDetails.investmentRisk.score
        debugger
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },
        assigningCustomerDataToFields() {
            this.declarationByCustomer.push(
                {
                    field: 'Has any Financial Institution ever refused to open your account?',
                    value:
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.declarationCustomer1 &&
                        this.customerDetails.accountInfo.declarationCustomer1[0]
                            ? this.customerDetails.accountInfo
                                  .declarationCustomer1[0]
                            : 'N/A',
                },
                {
                    field: 'Are you opening this Account on behalf of any other person?',
                    value:
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.declarationCustomer2 &&
                        this.customerDetails.accountInfo.declarationCustomer2[0]
                            ? this.customerDetails.accountInfo
                                  .declarationCustomer2[0]
                            : 'N/A',
                },
                {
                    field: 'Are you holding a position in any government/public of office?',
                    value:
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.declarationCustomer3 &&
                        this.customerDetails.accountInfo.declarationCustomer3[0]
                            ? this.customerDetails.accountInfo
                                  .declarationCustomer3[0]
                            : 'N/A',
                },
                {
                    field: 'Are you holding a position in any political party?',
                    value:
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.declarationCustomer4 &&
                        this.customerDetails.accountInfo.declarationCustomer4[0]
                            ? this.customerDetails.accountInfo
                                  .declarationCustomer4[0]
                            : 'N/A',
                }
            )
            this.pepDeclaration.push(
                {
                    field: 'DO YOU CURRENTLY HOLD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP1 &&
                        this.customerDetails.pepInfo.declarationPEP1[0]
                            ? this.customerDetails.pepInfo.declarationPEP1[0]
                            : 'N/A',
                },
                {
                    field: 'DID YOU HOLD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP2 &&
                        this.customerDetails.pepInfo.declarationPEP2[0]
                            ? this.customerDetails.pepInfo.declarationPEP2[0]
                            : 'N/A',
                },
                {
                    field: 'HAVE YOU EVER HELD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP3 &&
                        this.customerDetails.pepInfo.declarationPEP3[0]
                            ? this.customerDetails.pepInfo.declarationPEP3[0]
                            : 'N/A',
                },
                {
                    field: 'DID YOU HAVE OR HAVE YOU EVER HAD ANY DIPLOMATIC IMMUNITY?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP4 &&
                        this.customerDetails.pepInfo.declarationPEP4[0]
                            ? this.customerDetails.pepInfo.declarationPEP4[0]
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A RELATIVE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP5 &&
                        this.customerDetails.pepInfo.declarationPEP5[0]
                            ? this.customerDetails.pepInfo.declarationPEP5[0]
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A CLOSE ASSOCIATE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP6 &&
                        this.customerDetails.pepInfo.declarationPEP6[0]
                            ? this.customerDetails.pepInfo.declarationPEP6[0]
                            : 'N/A',
                },
                {
                    field: 'HAS THERE BEEN A CONVICTION AGAINST YOU BY A COURT OF LAW?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP7 &&
                        this.customerDetails.pepInfo.declarationPEP7[0]
                            ? this.customerDetails.pepInfo.declarationPEP7[0]
                            : 'N/A',
                },
                {
                    field: 'IF YOU HAVE ANSWERED "YES" TO ANY OF THE QUESTIONS ABOVE, PLEASE PROVIDE DETAILS:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepInfo &&
                        this.customerDetails.pepInfo.declarationPEP8
                            ? this.customerDetails.pepInfo.declarationPEP8
                            : 'N/A',
                }
            )
            this.ultimateBenefit.push(
                {
                    field: 'Name of Ultimate Beneficiary:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.ultimateBenName &&
                        this.customerDetails.accountInfo.ultimateBenName
                            ? this.customerDetails.accountInfo.ultimateBenName
                            : 'N/A',
                },
                {
                    field: 'Relationship with the Customer:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.ultimateBenRelation &&
                        this.customerDetails.accountInfo.ultimateBenRelation
                            ? this.customerDetails.accountInfo
                                  .ultimateBenRelation
                            : 'N/A',
                },
                {
                    field: 'CNIC/NICOP/Passport No.:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.accountInfo &&
                        this.customerDetails.accountInfo.ultimateBenIdNo &&
                        this.customerDetails.accountInfo.ultimateBenIdNo
                            ? this.customerDetails.accountInfo.ultimateBenIdNo
                            : 'N/A',
                }
            )
            this.factaDetails.push(
                {
                    field: 'Title of Account:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.titleOfAcc
                            ? this.customerDetails.fatcaInfo.titleOfAcc
                            : 'N/A',
                },
                {
                    field: 'CNIC No.:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CNICNumber &&
                        this.customerDetails.fatcaInfo.CNICNumber
                            ? this.customerDetails.fatcaInfo.CNICNumber
                            : 'N/A',
                },
                {
                    field: 'Country of tax residence other than Pakistan:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.CountryTax &&
                        this.customerDetails.fatcaInfo.CountryTax
                            ? this.customerDetails.fatcaInfo.CountryTax
                            : 'N/A',
                },
                {
                    field: 'Place of Birth:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.placeOfBirth &&
                        this.customerDetails.fatcaInfo.placeOfBirth
                            ? this.customerDetails.fatcaInfo.placeOfBirth
                            : 'N/A',
                },
                {
                    field: 'Are you a US Citizen?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSCitizen &&
                        this.customerDetails.fatcaInfo.isUSCitizen[0]
                            ? this.customerDetails.fatcaInfo.isUSCitizen[0]
                            : 'N/A',
                },
                {
                    field: 'Are you a US Resident?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSResident &&
                        this.customerDetails.fatcaInfo.isUSResident[0]
                            ? this.customerDetails.fatcaInfo.isUSResident[0]
                            : 'N/A',
                },
                {
                    field: 'Standing instructions to transfer funds to an account maintained in USA:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.transferInstructions &&
                        this.customerDetails.fatcaInfo.transferInstructions[0]
                            ? this.customerDetails.fatcaInfo
                                  .transferInstructions[0]
                            : 'N/A',
                },
                {
                    field: 'Do you have any Power of Attorney/Authorised Signatory/Mandate Holder having US Address?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.IsPowerAttorney &&
                        this.customerDetails.fatcaInfo.IsPowerAttorney[0]
                            ? this.customerDetails.fatcaInfo.IsPowerAttorney[0]
                            : 'N/A',
                },
                {
                    field: 'Do you have US residence/mailing/Sole Hold Mail Address?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isMailAddress &&
                        this.customerDetails.fatcaInfo.isMailAddress[0]
                            ? this.customerDetails.fatcaInfo.isMailAddress[0]
                            : 'N/A',
                },
                {
                    field: 'Do you have US telephone number?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.isUSTelephone &&
                        this.customerDetails.fatcaInfo.isUSTelephone[0]
                            ? this.customerDetails.fatcaInfo.isUSTelephone[0]
                            : 'N/A',
                },
                {
                    field: 'US Taxpayer Identification Number:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.fatcaInfo &&
                        this.customerDetails.fatcaInfo.USIdNumber &&
                        this.customerDetails.fatcaInfo.USIdNumber[0]
                            ? this.customerDetails.fatcaInfo.USIdNumber[0]
                            : 'N/A',
                }
            )
        },
    }, // End of Component > filters
} // End of export default
</script>
